module.exports = __webpack_public_path__ + "img/025_thumbnail.bb2172fc.jpg";